import { useEffect, useState } from 'react';
/**
 * returns the result of a prefers-reduced-motion media query
 * @return true = reduce | false = no-preference
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */
export function useReducedMotion() {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        setMatches(mediaQuery.matches);
        const handleChange = (event) => {
            setMatches(event.matches);
        };
        if (typeof mediaQuery.addEventListener !== 'undefined') {
            mediaQuery.addEventListener('change', handleChange);
        }
        else if (typeof mediaQuery.addListener !== 'undefined') {
            /**
             * ios safari <= 13 MediaQuery does not extend EventTarget
             * so doesn't have addEventListener
             * @see https://github.com/mdn/sprints/issues/858
             */
            mediaQuery.addListener(handleChange);
        }
        return () => {
            if (typeof mediaQuery.removeEventListener !== 'undefined') {
                mediaQuery.removeEventListener('change', handleChange);
            }
            else if (typeof mediaQuery.removeListener !== 'undefined') {
                mediaQuery.removeListener(handleChange);
            }
        };
    }, []);
    return matches;
}
